<template>
    <div class="p-grid">
		<div class="p-col-12">
			<div class="card p-shadow-1">
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-12">
                        <Message severity="warn" :sticky="true" :closable="false">
                            Atenção! <br/>
                            Essa ação redefine o saldo final.<br/>
                            Selecione com cuidado os funcionários.<br/>
                            Selecione o período correto.<br/>
                            Tenha cuidado, essa ação não pode ser desfeita.
                        </Message>
                    </div>                      
                </div> 

                <IKFiltroFuncionario ref="ikFiltroFuncionario"/>

                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-3">
                        <label>Data</label>
                        <Calendar v-model="mesAno" view="month" dateFormat="mm/yy" :showIcon="true" :manualInput="false" :yearNavigator="true" 
                        :yearRange="rangeData" :locale="localeCalendarBR"/>				
                    </div> 
                    <div class="p-field p-col-0">
                        <label style="color:#ffffff">.</label>  
                        <Button label="Concluir" icon="pi pi-calendar-times" @click="exibirModal"/>
                    </div> 
                </div>

                <Dialog :visible.sync="exibirDialogConfirmarZerar" header="Confirmar" :modal="true" :style="{width: '450px'}">
                    <div class="confirmation-content">
                    <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem; color:red" />
                    <span><b>Atenção!</b></span><br/>
                    <br/>
                    <p>
                        Todos os saldos serão zerados!
                    </p>
                    <p>
                        Essa ação não poderá se disfeita.
                    </p>  
                    <p>
                        Se realmente tem certeza clique em sim.
                    </p>        
                    </div>
                    <template #footer>
                    <Button label="Não" icon="pi pi-times" class="p-button-secondary" @click="exibirDialogConfirmarZerar = false"/>
                    <Button label="Sim" icon="pi pi-check" class="p-button-danger" @click="zerar" />
                    </template>
                </Dialog>
			</div>
		</div>
    </div>
</template>

<script>
import FuncionarioPesquisaService from '@/service/FuncionarioPesquisaService';
import IKFiltroFuncionario from '@/components/template/IKFiltroFuncionario';
import SaldoBancoHorasService from '@/service/SaldoBancoHorasService';
import Funcionario from '@/model/Funcionario';
import { exibirMensagem, exibirMensagemSis, localeCalendarBR, clonar } from '@/global';
import { mapGetters } from 'vuex';

export default {
    SaldoBancoHorasService: null,
    funcionarioPesquisaService: null,
    data() {
        return {   
            enviandoForm: false,
            exibirDialogConfirmarZerar: false,            
            permissaoNovo: false,
            permissaoEditar: false,
            permissaoExcluir: false,
            saldos: [],
            idCnpjSelecionado: null,
            cnpjs: [],
            funcionarioSelecionado: new Funcionario(),
            idCentroCustoSelecionado: null,
            centrosCustos: [],  
            funcionarios: null,         
            crachaNome: '',
            mesAno: new Date(),
            rangeData: '',     
            localeCalendarBR: localeCalendarBR                 
        }
    },
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao','getPermissoes']),               
        zerar() {
            let dados = this.$refs.ikFiltroFuncionario.getFuncionarios(); 
            if(dados.funcionarios.length == 0) {
                exibirMensagemSis(this, 'Selecione um ou mais funcionários', true);
                return;
            }   
            let requisicao = {                
                mes: this.mesAno.getMonth()+1,
                ano: this.mesAno.getFullYear(),
                funcionarios: clonar(dados.funcionarios),
                cnpj: dados.cnpj,
                usuarioRequisicao: {...this.getDadosRequisicao()}
            };
            this.SaldoBancoHorasService.zerar(requisicao)
            .then(resp => {       
                exibirMensagem(this, resp);                  
            })
            .catch(erro => {exibirMensagem(this, erro)});
            this.exibirDialogConfirmarZerar = false;
        },          
        exibirModal() {
            this.exibirDialogConfirmarZerar = true;
        },
        criarRangeData() {
            let anoAtual = new Date().getFullYear();     
            this.rangeData = (anoAtual-10)+':'+(anoAtual+20);     
        }
    },
	created() {
        this.funcionarioPesquisaService = new FuncionarioPesquisaService(); 
		this.SaldoBancoHorasService = new SaldoBancoHorasService();		
	},
	mounted() {	        
		this.criarRangeData();	
	},
    components: {
        'IKFiltroFuncionario': IKFiltroFuncionario,        
    }
}
</script>

<style>
    .negativo {
        color: #C13928;
    }
</style>